import React, { useEffect, useState } from 'react';
import './nav.css';
import { AiOutlineHome } from 'react-icons/ai';
import { AiOutlineUser } from 'react-icons/ai';
import { BiBook } from 'react-icons/bi';
import { RiServiceLine } from 'react-icons/ri';
import { BiMessageSquareDetail } from 'react-icons/bi';
import { RiGitRepositoryLine } from 'react-icons/ri';

export default function Nav() {
  const [activeNav, setActiveNav] = useState(window.location.href.split('#').pop() == undefined ? '#' : '#' + window.location.href.split('#').pop())

  useEffect(() => {
    const baseURLSplit = '#' + window.location.href.split('#').pop();
    setActiveNav(baseURLSplit);
    if (baseURLSplit !== '#') {
      console.log("!", document.getElementsByClassName("active"));
      const x = document.getElementsByClassName("active");
      if (x[0] === undefined) return;
      x[0].click();
    }
  }, [])

  return (
    <nav >
      <a href='#' onClick={() => setActiveNav('#')} className={activeNav === '#' ? 'active btn-animation' : 'btn-animation'}><AiOutlineHome /></a>
      <a href='#about' onClick={() => setActiveNav('#about')} className={activeNav === '#about' ? 'active btn-animation' : 'btn-animation'}><AiOutlineUser /></a>
      <a href='#experience' onClick={() => setActiveNav('#experience')} className={activeNav === '#experience' ? 'active btn-animation' : 'btn-animation'}><BiBook /></a>
      <a href='#services' onClick={() => setActiveNav('#services')} className={activeNav === '#services' ? 'active btn-animation' : 'btn-animation'}><RiServiceLine /></a>
      <a href='#portfolio' onClick={() => setActiveNav('#portfolio')} className={activeNav === '#portfolio' ? 'active btn-animation' : 'btn-animation'}><RiGitRepositoryLine /></a>
      {/* <a href='#testimonials' onClick={() => setActiveNav('#testimonials') } className={activeNav === '#testimonials' ? 'active' : ''}><RiServiceLine/></a> */}
      <a href='#contact' onClick={() => setActiveNav('#contact')} className={activeNav == '#contact' ? 'active btn-animation' : 'btn-animation'}><BiMessageSquareDetail /></a>
    </nav>
  )
}
